import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material";

@Component({
    selector: 'terms-and-conditions-cibil',
    templateUrl: './termsAndConditions.html',
    styleUrls: ['./termsAndConditions.scss'],
})
export class TermsAndConditionsCibilPopupComponent {
    private matDialogRef: MatDialogRef<TermsAndConditionsCibilPopupComponent>;

    constructor(
        matDialogRef: MatDialogRef<TermsAndConditionsCibilPopupComponent>
    ) {
        this.matDialogRef = matDialogRef;
    }
    
    onBackButtonClicked() {
        this.matDialogRef.close();
    }
}